
import {axiosHttp} from '@/util/axios.js'

/**
 * 企业信息
 * @param {position：位置} data 
 */
export function getCompanyInfoList(data) {
  return axiosHttp.$postAxios("/access/getCompanyInfoList", data)
}

/**
 * 应用信息 
 */
export function selectApplication(data) {
  return axiosHttp.$postAxios("/access/selectApplication", data)
}






// WEBPACK FOOTER //
// ./src/apis/company/index.js